import React from "react";
import "./schedule.css";

export const ScheduleButton = () => {
    return (
        <a className="button button--schedule" tabIndex="0" target="_blank" href="https://calendly.com/tq-david/45minutes">
            <span>Schedule a Demo</span>
        </a>
    );
}